import { IUserTicketData } from 'meta/pages/v4/ticket'
import { SliceSelector } from 'store/types'

const getUserTicketData: SliceSelector<IUserTicketData | undefined, { cod: string }> =
  ({ cod }) =>
  (state) =>
    state.pages.ticket.tickets[cod]

const getUserTypeTicketIdsForGivenEvent: SliceSelector<number[] | undefined, { eventId: number }> =
  ({ eventId }) =>
  (state) =>
    Object.values(state.pages.ticket.tickets)
      .filter((x) => x.eventId == eventId)
      .map((x) => x.typeTicketId)

export const TicketSelectors = {
  getUserTicketData,
  getUserTypeTicketIdsForGivenEvent,
}
